import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

import { computed } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'SelectCameraCheckBox',
  props: {
    modelValue: {},
    items: {},
    selectableItems: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit
const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, key) => {
    return (_openBlock(), _createBlock(_component_v_checkbox, {
      key: key,
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
      value: key,
      label: item,
      disabled: !props.selectableItems.includes(key) || props.disabled,
      density: "compact"
    }, null, 8, ["modelValue", "value", "label", "disabled"]))
  }), 128))
}
}

})